module.exports = __webpack_public_path__ + "img/grupo.66d1639d.svg";